import { all } from 'redux-saga/effects';
import getUserEmailSaga from './get_user_email.saga';
import createUserEmailSaga from './create_user_email.saga';
import changeUserEmailSaga from './change_user_email.saga';
import removeUserEmailSaga from './remove_user_email.saga';

export default function* userEmailsRootSaga() {
    yield all([
        getUserEmailSaga(),
        createUserEmailSaga(),
        changeUserEmailSaga(),
        removeUserEmailSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_emails_sagas/emails_root.saga.js